import { Component, OnInit, ViewChild } from '@angular/core';
import { Table, TableModule, TableRowCollapseEvent, TableRowExpandEvent } from 'primeng/table';
import { ImageModule } from 'primeng/image';
import { CardModule } from 'primeng/card';
import { CommonModule } from '@angular/common';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { Router } from '@angular/router';
import { TagModule } from 'primeng/tag';
import { LambdaService } from 'src/app/services/lambda.service';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { MessageService } from 'primeng/api';


@Component({
  selector: 'app-onvo-payments',
  imports: [TableModule, CommonModule,  ImageModule,CardModule, IconFieldModule, InputIconModule, TableModule, InputTextModule, CommonModule, IconFieldModule, InputIconModule, ButtonModule, TagModule, ProgressSpinnerModule],
  templateUrl: './onvo-payments.component.html',
  styleUrl: './onvo-payments.component.scss'
})
export class OnvoPaymentsComponent {

  onvoPayments: any = [];
  @ViewChild('dt') dt!: Table;
  loading = false;

  constructor(private router: Router, private lambdaService: LambdaService, private messageService: MessageService) {}

  ngOnInit(): void {
    this.loadOnvoPayments();
  }

  loadOnvoPayments(): void {
    this.loading = true;
    this.lambdaService.getOnvoPayments()
    .then((data:any) => {
      // console.log("shops: ",data.data)
      this.onvoPayments = data.data;
      console.log(this.onvoPayments);
    })
    .catch((error:Error) => {
      let errorMessage = 'Error al cargar las tiendas: ' + error;
      console.error(errorMessage);
    })
    .finally(()=>{
      setTimeout(() => {
        this.loading = false;
      }, 500);
    })
  }

  onInput(event: Event) {
    const input = event.target as HTMLInputElement; // Afirmación de tipo
    // console.log(input.value, "searching")
    this.dt.filterGlobal(input.value, 'contains'); // Usa el valor del input
  }

}
